import { useRef, useState } from "react";
import { CaretRight } from "../../utility/images/CaretRight";
import { eventMisfired } from "@dfa/ui-platform-react";
import { Card } from "../types/card-carousel-types";

type ImageCardProps = {
	card: Card;
	i: number;
	cardSize: number;
};

const ImageCard = ({ card, i, cardSize }: ImageCardProps) => {
	const cardRef = useRef<HTMLDivElement>(null);
	const [imageHover, setImageHover] = useState(false);

	const imageBackground = `linear-gradient(180deg, rgba(0, 0, 0, 0) 63.24%, rgba(0, 0, 0, 0.7) 100%), url(${
		window.location.origin + card.backgroundImage
	})`;

	const imageBackgroundHover = `linear-gradient(0deg, rgba(125, 125, 122, 0.35) 0%, rgba(125, 125, 122, 0.35) 100%), linear-gradient(180deg, rgba(0, 0, 0, 0.00) 63.24%, rgba(0, 0, 0, 0.70) 100%), url(${
		window.location.origin + card.backgroundImage
	})`;

	const imageBlend = "multiply, normal";
	const imageBlendHover = "soft-light, multiply, multiply, normal";

	const imageSlide = (
		<div
			ref={cardRef}
			className="carousel-card-image"
			key={"card-carousel" + i}
			onClick={() => {
				window.location.href = card.link;
			}}
			role="button"
			tabIndex={0}
			onKeyUp={() => {
				window.location.href = card.link;
			}}
			onMouseEnter={() => setImageHover(true)}
			onMouseLeave={() => setImageHover(false)}
			style={{
				height: cardSize,
				width: cardSize,
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundColor: "lightgray",
				backgroundImage: imageHover ? imageBackgroundHover : imageBackground,
				backgroundBlendMode: imageHover ? imageBlendHover : imageBlend
			}}
			data-a-evt="Link Click"
			data-a-comp="Card Carousel"
			data-a-name={card.title}
			data-a-linktype="Featured"
		>
			<div className="carousel-card-image-wrapper">
				<div className="carousel-card-image-wrapper-container">
					<div className="carousel-card-image-wrapper-text">
						<div className="carousel-card-image-wrapper-title t-body-xl tc-white">{card.title}</div>
						<div
							className="carousel-card-image-wrapper-link"
							role="button"
							tabIndex={0}
							onClick={() => {
								window.location.href = card.link;
							}}
							onKeyUp={(event) => {
								if (eventMisfired(event)) return;
								window.location.href = card.link;
							}}
						>
							<div
								className="carousel-card-image-wrapper-link-text"
								onClick={() => {
									window.location.href = card.link;
								}}
								onKeyUp={(event) => {
									if (eventMisfired(event)) return;
									window.location.href = card.link;
								}}
								role="button"
								tabIndex={0}
							>
								<div className="carousel-card-image-wrapper-link-text-description t-label-sm-heavy">
									{card.linkText}
								</div>
								<CaretRight />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
	return imageSlide;
};

export default ImageCard;
